module.exports = __webpack_public_path__ + "img/item2.080a505e.png";